module.exports = __webpack_public_path__ + "media/icons/search_circle-da57754c.svg";